import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../components/Loading';
import AdItem from '../components/JobAdItem';
import Pagination from '../components/Pagination';
import { startFetchJobAds } from '../actions/jobAds';
import { nextPage, prevPage, updateTerm } from '../actions/jobFilters';
import ListLaodingMore from '../components/ListLoadingItem';
import ListFinishedItem from '../components/ListFinishedItem';

const JobAds = (props) => {

    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        if (isLoading) {
            props.startFetchJobAds()
                .then(({ success, error }) => {
                    if (success) {
                        setLoading(false)
                    }
                    else {
                        setLoading(false)
                    }
                })
        }
    }, [isLoading])

    const handleNext = () => {
        props.nextPage();
        setLoading(true);
    }

    const handlePrev = () => {
        props.prevPage();
        setLoading(true);
    }

    const onTermChanged = (e) => {
        props.updateTerm(e.target.value)
    }

    const onSearchClicked = (e) => {
        setLoading(true);
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 px-0 ads pt-3">
            {
                (props.page === 1 && isLoading) ? (
                    <Loading />
                ) : (
                        <>
                            <div className="ads__search-bar d-none">
                                {/* <span className="ads__search-btn" onClick={onExpandClicked}><i class="material-icons m-2">filter_list</i></span> */}
                                <input className="ads__search-input" type="text" placeholder="دنبال چی می‌گردی؟" value={props.term || ""} onChange={onTermChanged} />
                                <span className="ads__search-btn" onClick={onSearchClicked}><i class="material-icons m-2">search</i></span>
                            </div>
                            <InfiniteScroll
                                dataLength={props.ads.length}
                                next={handleNext}
                                hasMore={props.page < props.pageCount}
                                loader={<ListLaodingMore />}
                                endMessage={<ListFinishedItem />}
                                height='89vh'
                            >
                                {
                                    props.ads.map(el => (<AdItem for="job-scroller" key={el.id} info={el} push={props.history.push} />))
                                }
                            </InfiniteScroll>
                        </>
                    )
            }
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    page: state.jobFilters.page,
    pageCount: Math.ceil(state.jobAds.total / state.jobFilters.page_size),
    ads: state.jobAds.items,
    term: state.jobFilters.term
});

const mapDispatchToProps = (dispatch) => ({
    nextPage: () => dispatch(nextPage()),
    prevPage: () => dispatch(prevPage()),
    updateTerm: (term) => dispatch(updateTerm({ term })),
    startFetchJobAds: () => dispatch(startFetchJobAds())
});

export default connect(mapStateToProps, mapDispatchToProps)(JobAds);